/* 绑定银行卡 */
<template>
  <div class="bank-card-box">
    <!-- 头部 -->
    <headerTop title="绑定银行卡"></headerTop>
    <!-- 内容 -->
    <div class="content">
      <div class="content-tips">
        <p>
          <span>为保证资金安全，请绑定账户本人的银行卡，用于</span>
          <span>账户余额提现</span>
        </p>
        <p>一经绑定，不能修改，请核对后添加</p>
      </div>
      <div class="information-box">
        <!-- 银行卡号 -->
        <div class="information-box-item card-number">
          <span>银行卡号</span>
          <input
            v-model="bankCardId"
            type="number"
            name="card"
            placeholder="请输入银行卡号"
            maxlength="19"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
          >
        </div>
        <!-- 银行 -->
        <div class="information-box-item bank">
          <van-field
            readonly
            clickable
            label="银行"
            :value="bankName"
            placeholder="选择银行"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @cancel="showPicker = false"
              @confirm="onConfirm"
            />
          </van-popup>
        </div>
        <!-- 开户行所在地区 -->
        <div class="information-box-item open-account-location" @click="getEmpty">
          <span>开户行所在地区</span>
          <span>{{ locName }}</span>
          <span class="iconfont iconyoujiantou"></span>
        </div>
        <!-- 开户行 -->
        <div class="information-box-item open-account">
          <span>开户行</span>
          <input
            v-model="bankBranch"
            type="text"
            name="account"
            maxlength="14"
            placeholder="请输入开户行"
          >
        </div>
        <!-- 姓名 -->
        <div class="information-box-item user-name">
          <span>持卡人姓名</span>
          <input v-model="bankCardOwner" type="text" name="codeid" placeholder="请输入姓名">
        </div>
        <!--身份证号 -->
        <div class="code-box">
          <div class="information-box-item id-code">
            <span>身份证号</span>
            <input
              v-model="ownerIdCard"
              @blur="checkOwnerIdCard"
              type="text"
              name="username"
              maxlength="18"
              placeholder="请输入身份证号"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
            >
          </div>
          <div class="code-tips" v-if="!ownerIdCardStatus">
            <span class="iconfont iconjingshi"></span>
            <span>15或18位数字，末位可为X</span>
          </div>
        </div>
        <!-- 银行预留手机号 -->
        <div class="phone-box">
          <div class="information-box-item phone">
            <span>银行预留手机号</span>
            <input
              v-model="bankPhone"
              @blur="checkBankPhone"
              type="text"
              name="phone"
              maxlength="11"
              placeholder=""
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
            >
          </div>
          <div class="code-tips" v-if="!bankPhoneStatus">
            <span class="iconfont iconjingshi"></span>
            <span>请勿必填写该银行卡留在银行的手机号</span>
          </div>
        </div>
        <!-- 用户协议 -->
        <div class="agreement" @click="agreementHref">
          <span>查看</span>
          <span>《用户协议》</span>
        </div>
      </div>
    </div>
    <!-- 底部按钮 -->
    <div class="foot-btn">
      <loading-btn btnClass="btn" v-preventReClick @click="submitBank">同意协议并验证</loading-btn>
    </div>
    <!-- 弹窗 -->
    <div class="empty-box">
      <van-popup v-model="show" position="bottom" :style="{ height: '66%' }">
        <div class="tltle">
          <span>开户行所在地区</span>
          <span @click="show = false" class="iconfont iconguanbi"></span>
        </div>
        <div class="tabs">
          <ul class="tab-title">
            <li
              v-for="(item, index) in titleItems"
              :key="index"
              @click="contentActive(item.level, index, false)"
            >
              <span :class="{'span-active':-1===item.is_show}">{{item.name}}</span>
            </li>
            <li v-if="isPleaseChoose">
              <span :class="{'span-active':pleaseChooseActive}">请选择</span>
            </li>
          </ul>
          <ul class="tab-content">
            <li
              v-for="(item,contentIndex) in contentItems"
              :key="contentIndex"
              @click="contentActive(item.level, contentIndex, true)"
            >
              <span
                :class="{'span-active':(item.level===2 && locProvinceIndex===contentIndex) || 
                (item.level===3 && locCityIndex===contentIndex) || 
                (item.level===4 && locCountyIndex===contentIndex)}"
              >{{item.name}}</span>
            </li>
          </ul>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import loadingBtn from "@/components/common/loadingBtn";
import javaApi from "@/api/javaApi";
import commonApi from "@/api/commonApi";
import validationMixin from "@/mixins/validationMixin";
import validate from "@/libs/validate";
import accountApi from "@/api/accountApi";

export default {
  data() {
    return {
      bankCardId: "", // 银行卡号
      bankName: "", // 银行名称
      bankBranch: "", // 开户行
      bankCardOwner: "", // 持卡人姓名
      ownerIdCard: "", // 身份证号码
      bankPhone: "", // 银行预留手机号
      ownerIdCardStatus: true, // 示身份证号码是否正确
      bankPhoneStatus: true, // 银行预留手机号是否正确
      showPicker: false,
      columns: [],
      locProvince: "",
      locCity: "",
      locCounty: "",
      show: false,
      locName: "所在地区",
      titleItems: [],
      contentItems: [],
      allLocation: {}, // 所有区域
      locProvinceIndex: -1, // 选中的省
      locCityIndex: -1, // 选中的市
      locCountyIndex: -1, // 选中的区
      pleaseChooseActive: true, // 是否选中请选择
      isPleaseChoose: true // 是否显示请选择
    };
  },
  methods: {
    getEmpty() {
      this.show = true;
    },
    clearActive() {
      this.contentItems.map(item => {
        item.active = false;
      });
    },
    clearTitleActive() {
      this.titleItems.map(item => {
        item.is_show = 1;
      });
    },
    contentActive(level, index, changeTitle) {
      let res;

      this.clearTitleActive();
      if (changeTitle === false) {
        this.pleaseChooseActive = false;
        level--;
        this.titleItems[index].is_show = -1;
        if (index == 0) {
          //
        } else if (index == 1) {
          index = this.locProvinceIndex;
        } else if (index == 2) {
          index = this.locCityIndex;
        }
      } else {
        this.pleaseChooseActive = true;
      }

      if (changeTitle)
        this.titleItems = this.titleItems.slice(
          0,
          this.contentItems[index].level - 2
        );
      if (changeTitle) this.isPleaseChoose = true;

      // 省市区判断，记录下标，得到下级菜单
      if (level == 2) {
        this.locProvinceIndex = index;
        res = this.allLocation[index].sub;
        if (changeTitle) {
          this.titleItems = this.titleItems.concat(this.allLocation[index]);
          this.locCityIndex = this.locCountyIndex = -1;
        }
      } else if (level == 3) {
        this.locCityIndex = index;
        res = this.allLocation[this.locProvinceIndex].sub[index].sub;
        if (changeTitle) {
          this.titleItems = this.titleItems.concat(
            this.allLocation[this.locProvinceIndex].sub[index]
          );
          this.locCountyIndex = -1;
        }
        if (res == undefined) {
          res = this.allLocation[this.locProvinceIndex].sub;
          this.show = false;
        }
      } else if (level == 4) {
        this.locCountyIndex = index;
        res = this.allLocation[this.locProvinceIndex].sub[this.locCityIndex]
          .sub;
        if (changeTitle)
          this.titleItems = this.titleItems.concat(
            this.allLocation[this.locProvinceIndex].sub[this.locCityIndex].sub[
              index
            ]
          );
        this.show = false;
      } else {
        res = this.allLocation;
      }

      this.contentItems = res;
      if (this.show == false) {
        this.clearActive();
        this.isPleaseChoose = false;

        this.pleaseChooseActive = false;
        this.titleItems[this.titleItems.length - 1].is_show = -1;
        this.locName = "";
        this.titleItems.map((item, index) => {
          if (index == 0) {
            this.locProvince = item.id;
          } else if (index == 1) {
            this.locCity = item.id;
          } else if (index == 2) {
            this.locCounty = item.id;
          }
          this.locName = this.locName + item.name;
        });
      }
    },
    onConfirm(value) {
      this.bankName = value;
      this.showPicker = false;
    },
    submitBank() {
      let validations = [
        {
          value: this.bankCardId,
          method: "required",
          message: "请输入银行卡号"
        },
        {
          value: this.bankName,
          method: "required",
          message: "请选择银行名称"
        },
        {
          value: this.locProvince,
          method: "required",
          message: "请选择开户行所在地区"
        },
        {
          value: this.bankBranch,
          method: "required",
          message: "请输入开户行"
        },
        {
          value: this.bankCardOwner,
          method: "required",
          message: "请输入持卡人姓名"
        },
        {
          value: this.ownerIdCard,
          method: "required",
          message: "请输入身份证号码"
        },
        {
          value: this.ownerIdCard,
          method: "idcard",
          message: "身份证号码输入错误"
        },
        {
          value: this.bankPhone,
          method: "required",
          message: "请输入银行预留手机号"
        }
        // {
        //   value: this.bankPhone,
        //   method: "tel",
        //   message: "银行预留手机号输入错误"
        // }
      ];

      if (this.check(validations)) {
        let data = {
          bank_card_owner: this.bankCardOwner,
          bank_phone: this.bankPhone,
          owner_id_card: this.ownerIdCard,
          bank_name: this.bankName,
          bank_branch: this.locName + this.bankBranch,
          bank_card_id: this.bankCardId
        };
        javaApi.accountBank(data).then(res => {
          console.log(data);
          if (res.subCode == 3028) {
            this.bankPhoneStatus = false;
          } else if (res.subCode != 200) {
            this.tips(res.subMsg);
          } else {
            const data = res.data;
            if (data.id !== undefined) {
              this.$store.commit("setAccountBankObj", {
                bank_branch: data.bankBranch,
                bank_card_id: data.bankCardId,
                bank_card_owner: data.bankCardOwner,
                bank_name: data.bankName,
                bank_phone: data.bankPhone,
                id: data.id,
                owner_id_card: data.ownerIdCard
              });
              this.$router.push({
                name: "bindingResult"
              });
            }
          }
        });
      }
    },
    checkOwnerIdCard() {
      this.ownerIdCardStatus = validate.idcard(this.ownerIdCard);
    },
    checkBankPhone() {
      this.bankPhoneStatus = validate.tel(this.bankPhone);
    },
    agreementHref() {
      this.$router.push({
        name: "bankCardAgreement"
      });
    }
  },
  components: {
    headerTop,
    loadingBtn
  },
  mixins: [validationMixin],
  async mounted() {
    commonApi.locationSub().then(res => {
      this.allLocation = res;
      this.contentItems = res;
    });
    this.columns = this.$store.state.systemConfig.bank_list;

    let res = await accountApi.accountBank();
    if (res.id !== undefined) {
      this.$router.push({
        name: "boundCard"
      });
    }
  }
};
</script>

<style lang="less" >
.bank-card-box {
  position: relative;
  .content {
    padding: 0 15px;
    .content-tips {
      padding-top: 28px;
      font-size: 14px;
      color: #999999;
      & p:nth-child(1) {
        & span:nth-child(2) {
          color: #ea2c2c;
        }
        margin-bottom: 3px;
      }
    }
    .information-box {
      margin-top: 15px;
      .information-box-item {
        display: flex;
        align-items: center;
        height: 44px;
        width: 100%;
        justify-content: space-between;
        border-bottom: 1px solid #e4e4e4;
        input {
          text-align: right;
          width: 180px;
        }

        input::-webkit-input-placeholder {
          text-align: right;
          color: #b2b2b2;
        }
      }
      .bank {
        .van-picker-column {
          flex: none !important;
          width: 100%;
        }

        .van-cell {
          background-color: transparent;
          padding: 10px 0;
          .van-cell__value {
            width: 100%;
            .van-field__body {
              width: 100%;
              input {
                width: 100% !important;
              }
            }
          }
        }
        .van-picker__frame {
          width: 0 !important;
        }
      }
      .open-account-location {
        span:nth-child(2) {
          width: 200px;
          text-align: right;
        }
        span:nth-child(3) {
          font-size: 12px;
          color: #999999;
        }
      }
      .open-account {
        input {
          width: 201px;
        }
      }
      .code-box {
        .code-tips {
          margin-bottom: 5px;
          display: flex;
          margin-top: 4px;
          & span:nth-child(1) {
            font-size: 14px;
            color: #ea2c2c;
          }
          & span:nth-child(2) {
            font-size: 12px;
            color: #ea2c2c;
          }
        }
      }
      .phone-box {
        input {
          width: 187px;
        }
        .code-tips {
          display: flex;
          margin-top: 4px;
          margin-bottom: 5px;
          & span:nth-child(1) {
            font-size: 14px;
            color: #ea2c2c;
          }
          & span:nth-child(2) {
            font-size: 12px;
            color: #ea2c2c;
          }
        }
      }
      .agreement {
        margin-top: 10px;
        & span:nth-child(1) {
          font-size: 14px;
          color: #999999;
        }
        & span:nth-child(2) {
          margin-left: 2px;
          font-size: 14px;
          color: #000034;
        }
      }
    }
  }
  .foot-btn {
    padding: 0 30px;
    margin-top: 22px;
    .btn {
      background: #ea2c2c;
      width: 100%;
      height: 44px;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 44px;
    }
    .btn-active {
      background: #d1d1d1;
      width: 100%;
      height: 44px;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 44px;
    }
  }
  .empty-box {
    .van-popup--bottom {
      padding: 0 15px 15px 15px;
      .tabs {
        height: 38px;
        width: 100%;
        margin-top: 40px;
        .tab-title {
          padding-top: 7px;
          display: flex;
          width: 100%;
          height: 38px;
          position: fixed;
          background-color: #fff;
          border-bottom: 1px solid #e4e4e4;
          li {
            padding-right: 40px;

            span {
              font-size: 14px;
              color: #333333;
            }
            .span-active {
              font-size: 14px;
              color: #ea2c2c;
              position: relative;
              &:before {
                content: "";
                position: absolute;
                bottom: -10px;
                width: 100%;
                height: 2px;
                background-color: #ea2c2c;
              }
            }
          }
        }
        .tab-content {
          padding: 50px 0 20px 0;
          li {
            padding-bottom: 18px;
            span {
              font-size: 14px;
              color: #333333;
            }
            .span-active {
              font-size: 14px;
              color: #ea2c2c;
            }
          }
        }
      }
    }
    .tltle {
      display: flex;
      justify-content: space-between;
      position: fixed;
      width: 100%;
      background-color: #fff;
      height: 50px;
      line-height: 50px;
      z-index: 99999;
      padding-right: 30px;
      & span:nth-child(1) {
        font-size: 16px;
        color: #1d1d1d;
        font-weight: 700;
      }
      & span:nth-child(2) {
        font-size: 16px;
        color: #b2b2b2;
      }
    }
  }
}
</style>
